export const CONTROL_LABELS = {
  move: 'WASD / 方向键',
  moveWasd: 'WASD',
  run: 'Shift',
  interact: 'E',
  confirm: 'E / Space',
  dash: 'Space',
  dialogSkip: 'Ctrl',
  menuSelect: '↑↓',
  menuAdjust: '←→',
  quest: 'Q',
  inventory: 'I',
  map: 'M',
  settings: 'O',
  minimap: 'Tab',
  system: 'Esc',
  quickSave: 'F4',
  saveMenu: 'F6',
  quickLoad: 'F9',
  mute: 'N',
  poemUltimate: 'K',
  knife: 'J',
  shoot: '鼠标左键',
  utterance: 'F',
};

export const CONTROL_HINTS = {
  startMenu: [
    `移动：${CONTROL_LABELS.move}，交互：${CONTROL_LABELS.interact}，冲刺：${CONTROL_LABELS.dash}`,
    `战斗形态随机：弹幕（${CONTROL_LABELS.menuAdjust} 菜单 + WASD 躲）/ 言锋（空格发字）/ 骇入（射击）；${CONTROL_LABELS.poemUltimate} 大招`,
    `菜单：${CONTROL_LABELS.quest} 任务，${CONTROL_LABELS.inventory} 背包，${CONTROL_LABELS.map} 地图，${CONTROL_LABELS.settings} 设置，${CONTROL_LABELS.system} 系统菜单，${CONTROL_LABELS.quickSave}/${CONTROL_LABELS.quickLoad} 快速存读档`,
  ],
  tutorialKeys: [
    { k: CONTROL_LABELS.moveWasd, d: `移动 · ${CONTROL_LABELS.run} 奔跑` },
    { k: CONTROL_LABELS.interact, d: '交互 / 拾取 / 开始对话' },
    { k: CONTROL_LABELS.utterance, d: '补全诗句/成语（靠近招牌或失语者）' },
    { k: '方向键', d: '战斗中移动红心 / 选菜单' },
    { k: CONTROL_LABELS.quest, d: '任务面板' },
    { k: CONTROL_LABELS.dash, d: '对话确认 / 战斗确认 / 攻击瞄准确认 / 大地图冲刺' },
    { k: CONTROL_LABELS.dialogSkip, d: '对话中按住快进' },
    { k: CONTROL_LABELS.poemUltimate, d: '战斗中释放诗词大招（需集齐完整诗句）' },
    { k: CONTROL_LABELS.inventory, d: '背包' },
    { k: CONTROL_LABELS.settings, d: '设置 / 无障碍选项' },
    { k: CONTROL_LABELS.minimap, d: '小地图开关' },
    { k: CONTROL_LABELS.system, d: '系统菜单（存档 / 读档 / 设置）' },
    { k: `${CONTROL_LABELS.quickSave}/${CONTROL_LABELS.quickLoad}`, d: '快速存档 / 读档' },
    { k: CONTROL_LABELS.mute, d: '静音切换' },
  ],
  worldFooter: `${CONTROL_LABELS.quest} 任务 · ${CONTROL_LABELS.map} 地图 · ${CONTROL_LABELS.inventory} 背包 · ${CONTROL_LABELS.utterance} 补诗`,
  utteranceOpen: `${CONTROL_LABELS.utterance} · 补全诗句`,
  interactObject: `${CONTROL_LABELS.interact} · 交互`,
  interactElder: `${CONTROL_LABELS.interact} · 老人`,
  interactReturn: `${CONTROL_LABELS.interact} · 返回街道`,
  interactEngrave: `${CONTROL_LABELS.interact} · 刻字`,
  interactKeystone: `${CONTROL_LABELS.interact} · 激活要石`,
  knife: `${CONTROL_LABELS.knife} · 挥刀`,
  battleDodge: `躲避弹幕：用 ${CONTROL_LABELS.move} 移动红心`,
  battleAim: `按 ${CONTROL_LABELS.confirm} 在中心位置停下，造成最大伤害`,
  battleConfirm: `${CONTROL_LABELS.menuAdjust} 选择 · ${CONTROL_LABELS.confirm} 确认`,
  battleUltimate: `${CONTROL_LABELS.poemUltimate} 诗词大招`,
  riversideIntro: `从上方落下可踩死梗鬼；按 ${CONTROL_LABELS.knife} 挥刀近战`,
  riversideReturn: `空格/W 跳跃 · ${CONTROL_LABELS.knife} 挥刀 · 老人旁光圈按 ${CONTROL_LABELS.interact} 返回街道 · 中段有要石`,
  level3dIntro: `（调试）维度裂隙：${CONTROL_LABELS.moveWasd} 移动 · 鼠标视角 · ${CONTROL_LABELS.shoot} 射击`,
  level3dGun: `（调试）捡到「刻字枪」！${CONTROL_LABELS.shoot} 射击`,
  saveMenuSave: `${CONTROL_LABELS.menuSelect} 选择槽位   ${CONTROL_LABELS.menuAdjust} 切换保存/读取   ${CONTROL_LABELS.interact} 保存或覆盖   Delete 删除   ${CONTROL_LABELS.saveMenu}/${CONTROL_LABELS.system} 关闭`,
  saveMenuLoad: `${CONTROL_LABELS.menuSelect} 选择槽位   ${CONTROL_LABELS.menuAdjust} 切换保存/读取   ${CONTROL_LABELS.interact} 读取   Delete 删除手动槽   ${CONTROL_LABELS.saveMenu}/${CONTROL_LABELS.system} 关闭`,
};
